/** Level 8 (claude/level-8-source): Lessons 1–28 teaching, Lesson 29 cumulative review, plus the lettered lessons not in the book yet (extra.ts); the Final Check-Up follows. */
import type { Lesson } from "../types";
import * as A from "./lesson01to14";
import * as B from "./lesson15to29";
import * as X from "./extra";

export const LEVEL8: Lesson[] = [
  A.L8_LESSON1, A.L8_LESSON2, A.L8_LESSON3, X.L8_LESSON3A, A.L8_LESSON4, A.L8_LESSON5, X.L8_LESSON5A, A.L8_LESSON6, A.L8_LESSON7, A.L8_LESSON8, A.L8_LESSON9, A.L8_LESSON10,
  A.L8_LESSON11, A.L8_LESSON12, X.L8_LESSON12A, A.L8_LESSON13, A.L8_LESSON14,
  B.L8_LESSON15, B.L8_LESSON16, B.L8_LESSON17, X.L8_LESSON17A, B.L8_LESSON18, B.L8_LESSON19, X.L8_LESSON19A, B.L8_LESSON20, B.L8_LESSON21, X.L8_LESSON21A, B.L8_LESSON22, B.L8_LESSON23, B.L8_LESSON24,
  B.L8_LESSON25, X.L8_LESSON25A, B.L8_LESSON26, B.L8_LESSON27, B.L8_LESSON28, B.L8_LESSON29,
];
export { L8_PRE, L8_POST } from "./checkups";
